module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Freight Consolidation Executions Details")]), _vm._v(" "), _c('Filter-Agency-Modal'), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard')], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    class: 'ml-4' + _vm.visible ? null : 'collapsed',
    attrs: {
      "variant": _vm.Filter.activeButtonFilter ? 'outline-danger' : 'outline-primary',
      "aria-expanded": _vm.Filtervisible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.Filtervisible = !_vm.Filtervisible;
        _vm.clearBranchBtnFilter();
      }
    }
  }, [_vm._v(_vm._s(_vm.Filtervisible ? "Filter ON" : "Filter OFF"))])], 1), _vm._v(" "), (_vm.Filtervisible) ? _c('b-col', {
    staticClass: "d-flex flex-wrap",
    attrs: {
      "md": "5"
    }
  }, [_c('b-button', {
    staticClass: "mr-1 mb-1",
    attrs: {
      "pressed": _vm.activeButtonBranch,
      "variant": _vm.activeButtonBranch ? 'success' : 'danger'
    },
    on: {
      "click": function($event) {
        _vm.BranchBtnFilter('Branch')
      }
    },
    model: {
      value: (_vm.Filter.activeButtonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "activeButtonFilter", $$v)
      },
      expression: "Filter.activeButtonFilter"
    }
  }, [_vm._v("Branch " + _vm._s(_vm.activeButtonBranch ? " Filter On" : " Filter Off"))]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-1 mb-1",
    attrs: {
      "pressed": _vm.activeButtonClient,
      "variant": _vm.activeButtonClient ? 'success' : 'danger'
    },
    on: {
      "click": function($event) {
        _vm.BranchBtnFilter('Client')
      }
    },
    model: {
      value: (_vm.Filter.activeButtonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "activeButtonFilter", $$v)
      },
      expression: "Filter.activeButtonFilter"
    }
  }, [_vm._v("Client " + _vm._s(_vm.activeButtonClient ? " Filter On" : " Filter Off"))]), _vm._v(" "), (_vm.Filter.activeButtonFilter) ? _c('div', [_c('model-list-select', {
    attrs: {
      "list": _vm.BranchInvStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Inv/BL Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.activeTallyBLFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "activeTallyBLFilter", $$v)
      },
      expression: "Filter.activeTallyBLFilter"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "ml-auto",
    attrs: {
      "md": "5"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "ml-auto pull-right mr-1"
  }, [_c('b-nav-form', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("New Assignment")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.addPrerequisite
    }
  }, [_vm._v("New Prerequisite")]), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.goRolloverCont
    }
  }, [_vm._v("Rollover Container")])], 1)], 1), _vm._v(" "), (_vm.FFExport.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1 mr-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('FF_CON_SEA_EXPORT', 'Export As Excel')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mb-1 mr-1",
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.gotoPendency()
      }
    }
  }, [_vm._v("\n            Show Pendency List\n          ")])], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row align-items-end"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-group', {
    staticStyle: {
      "margin-bottom": "0 !important"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search  (Assignment No. / Client / Container No./SB No. Shipper Inv No.)"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Months/Year")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.dateStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Date Filter"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.dateStatusFilter),
      callback: function($$v) {
        _vm.dateStatusFilter = $$v
      },
      expression: "dateStatusFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Sob Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.SOBStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select SOB Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.SOBFilter),
      callback: function($$v) {
        _vm.SOBFilter = $$v
      },
      expression: "SOBFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Prealert Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PrealertStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Prealert Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.PrealertFilter),
      callback: function($$v) {
        _vm.PrealertFilter = $$v
      },
      expression: "PrealertFilter"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.FFExport,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "ffFclConsoExportId",
      fn: function(row0) {
        return [(row0.item.rollover_event_code == 1) ? _c('span', {
          class: {
            alert: true,
              'alert-danger-text': row0.item.rollover_event_code == 1,
              blink: row0.item.rollover_event_code == 1,
          }
        }, [_c('br'), _vm._v("This Event is Rollover")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "ffExportFclConsoSeries",
      fn: function(row01) {
        return [_c('div', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              row01.item.is_locked == '1' &&
                (row01.item.finalBillingCompleted == 1 ||
                  row01.item.locked_counter > 0) &&
                _vm.$sessionsStorage.get('designation') != 'Admin' &&
                _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
                '' :
                _vm.viewExportFCLConPage(row01.item.ffFclConsoExportId)
            }
          }
        }, [_c('span', [_vm._v("\n                Assignment No.: " + _vm._s(row01.item.ffExportFclConsoSeries) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                Raised From: " + _vm._s(row01.item.EmpLoc) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                Date : " + _vm._s(_vm._f("moment")(row01.item.loginTime)) + "\n                "), _c('br')]), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": row01.item.is_locked == '1' &&
              (row01.item.finalBillingCompleted == 1 ||
                row01.item.locked_counter > 0) ?
              'danger' :
              'success'
          },
          on: {
            "click": function($event) {
              row01.item.is_locked == '1' &&
                (row01.item.finalBillingCompleted == 1 ||
                  row01.item.locked_counter > 0) ?
                _vm.LockUnLock(row01.item, 'locked') :
                ''
            }
          }
        }, [(
          row01.item.is_locked == '1' &&
          (row01.item.finalBillingCompleted == 1 ||
            row01.item.locked_counter > 0)
        ) ? _c('b', [_c('i', {
          staticClass: "fa fa-lock mr-1 lg"
        }), _vm._v("LOCKED")]) : _c('b', [_c('i', {
          staticClass: "fa fa-unlock mr-1 lg"
        }), _vm._v("UN-LOCKED")])]), _c('br'), _vm._v(" "), _c('b', {
          style: ('color:black')
        }, [_vm._v("Billing : ")]), _vm._v(" "), ((row01.item.finalBillingCompleted == '1')) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed")]) : (row01.item.finalBillingCompleted == '4') ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed - Agent\n                Expense Pending")]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Billing In-complete")]), _c('br'), _vm._v(" "), (row01.item.is_prealertSend == '1') ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Prealert Send : ")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_c('b', [_vm._v("YES")])]), _c('br')], 1) : _vm._e(), _vm._v(" "), (row01.item.is_prealertSend == '0') ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Prealert Send : ")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("NO")])]), _c('br')], 1) : _vm._e(), _vm._v(" "), (
          row01.item.sob_date_detected != '' &&
          row01.item.sob_date_detected != null
        ) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("SOB : " + _vm._s(row01.item.sob_date_detected))]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("SAILED")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row01.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row01.item.allModuleId,
            "jb_series": row01.item.ffExportFclConsoSeries
          }
        }), _vm._v(" "), (row01.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row01.item.ffExportFclConsoSeries,
            "PMC_JOBID": row01.item.allModuleId,
            "PMC_JOBNO": row01.item.ffExportFclConsoSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row01.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row01.item.ffExportFclConsoSeries,
            "PMC_JOBID": row01.item.allModuleId,
            "PMC_JOBNO": row01.item.ffExportFclConsoSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row01.item.allModuleId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' +
              row01.item.ffExportFclConsoSeries,
            "PMC_JOBID": row01.item.allModuleId,
            "PMC_JOBNO": row01.item.ffExportFclConsoSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('MSDeleteRequest', {
          attrs: {
            "item": row01.item,
            "JobNo": row01.item.ffExportFclConsoSeries,
            "JobID": row01.item.allModuleId,
            "sessionsStorage": _vm.$sessionsStorage
          },
          on: {
            "refreshData": _vm.handleRefresh
          }
        }), _vm._v(" "), (row01.item.deleteRequestBy != '' && row01.item.deleteRequestBy != '0' && row01.item.deleteRequestBy != null) ? _c('b', [_vm._v("Requested\n              By : " + _vm._s(row01.item.deleteRequestBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row01.item.deleteArrovedBy != '' && row01.item.deleteArrovedBy != '0' && row01.item.deleteArrovedBy != null) ? _c('b', [_vm._v("Arroved\n              By : " + _vm._s(row01.item.deleteArrovedBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row01.item.allModuleId) ? _c('WebhookLogSummary', {
          attrs: {
            "showTriggerButton": true,
            "PMC_title": 'Webhook Log ',
            "PMC_JOBID": row01.item.allModuleId,
            "PMC_JOBNO": row01.item.ffExportFclConsoSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row01.item.allModuleId) ? _c('AssignmentSplitMergeSummary', {
          attrs: {
            "PMC_title": 'Assignment Split/Merge/Move Summary',
            "PMC_JOBID": row01.item.allModuleId,
            "PMC_JOBNO": row01.item.ffExportFclConsoSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
          style: (row01.item.SubscriptionId ? 'color: blue;font-weight:bold' : ''),
          on: {
            "click": function($event) {
              row01.item.SubscriptionId ? _vm.goToSubscriptionPage(row01.item) : ''
            }
          }
        }, [_vm._v("\n              Booking No: " + _vm._s(row01.item.bookingNumber) + "\n              "), _c('br')])]
      }
    }, {
      key: "clientName",
      fn: function(row2) {
        return [(
          row2.item &&
          row2.item.NotificationAlert2 &&
          row2.item.NotificationAlert2.length > 0
        ) ? _c('div', _vm._l((row2.item.NotificationAlert2), function(item, index2) {
          return _c('div', {
            key: index2,
            staticClass: "status-alerts"
          }, [_c('span', {
            class: {
              alert: true,
                'alert-danger-text': item.type == 2,
                blink: item.type == 2,
            }
          }, [_c('strong', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.message) ? [_vm._v("\n                    - "), _c('strong', [_vm._v(_vm._s(item.message)), _c('br'), _vm._v(_vm._s(item.conclusion))])] : _vm._e()], 2), _vm._v(" "), _c('br')])
        })) : _c('div'), _vm._v(" "), _c('span', [_vm._v(_vm._s(row2.item.clientName))])]
      }
    }, {
      key: "placeRecp",
      fn: function(row11) {
        return [(row11.item.allModuleId && row11.item.containerNo) ? _c('ContaierWebLogSummary', {
          attrs: {
            "PMC_title": 'Container Event Summary Job No - ' + row11.item.ffExportFclConsoSeries,
            "PMC_JOBID": row11.item.allModuleId,
            "PMC_JOBNO": row11.item.ffExportFclConsoSeries,
            "PMC_CONTNO": row11.item.containerNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('BookingTrack', {
          attrs: {
            "containerArr": row11.item.containerNo,
            "slineName": row11.item.shippingLine,
            "clientName": row11.item.clientName,
            "modal_title": ("Container Movement Booking No: " + (row11.item.bookingNumber) + " Job No - " + (row11.item.ffExportFclConsoSeries) + " Client: " + (row11.item.clientName)),
            "JOBNO": row11.item.ffExportFclConsoSeries,
            "shipment_id": Number(0),
            "subscription_id": Number(0),
            "fk_sub_track_id": Number(0),
            "fk_all_module_id": Number(row11.item.allModuleId),
            "fk_booking_id": Number(row11.item.fk_booking_id),
            "fk_container_id": Number(0),
            "booking_number": row11.item.bookingNumber,
            "container_number": ''
          }
        }), _vm._v(" "), _c('div', [_c('span', [_vm._v("\n                Shipping Line : " + _vm._s(row11.item.shippingLine) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                POR : " + _vm._s(row11.item.placeRecp) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                Load Port : " + _vm._s(row11.item.LoadPort) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                POD : " + _vm._s(row11.item.placeDis) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                FPOD : " + _vm._s(row11.item.finalPlace) + "\n                "), _c('br')])])]
      }
    }, {
      key: "eta_details",
      fn: function(row321) {
        return [(row321.item.ETA_destination_estimated != '') ? _c('span', [_vm._v("Tentative : " + _vm._s(row321.item.ETA_destination_estimated))]) : _vm._e(), _vm._v(" "), (row321.item.ETA_destination_actual != '') ? _c('span', [_c('br'), _vm._v("Actual : " + _vm._s(row321.item.ETA_destination_actual))]) : _vm._e()]
      }
    }, {
      key: "subs_conclusion",
      fn: function(row322) {
        return [(
          row322.item.sub_noti_event_message != '' && row322.item.sub_noti_event_message != null
        ) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Event MSG : " + _vm._s(row322.item.sub_noti_event_message))]), _c('br')]) : _vm._e(), _vm._v(" "), (
          row322.item.sub_noti_risk != '' && row322.item.sub_noti_risk != null
        ) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Status : " + _vm._s(row322.item.sub_noti_risk_verbose))]), _c('br')]) : _vm._e(), _vm._v(" "), (
          row322.item.sub_noti_risk != '' && row322.item.sub_noti_risk != null
        ) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Desc : " + _vm._s(row322.item.sub_noti_risk_description))]), _c('br')]) : _vm._e(), _vm._v(" "), (
          row322.item.sub_noti_risk != '' && row322.item.sub_noti_risk != null
        ) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("Conclusion : " + _vm._s(row322.item.sub_noti_conclusion))])]) : _vm._e(), _vm._v(" "), _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row322.item.allModuleId,
            "fk_client_id": row322.item.clientId,
            "fk_pod_id": row322.item.PODLocationId
          }
        }), _vm._v(" "), (
          row322.item.is_locked == '1' &&
          row322.item.is_prealertSend == '1' &&
          (row322.item.CountmainManifestationData <= 0 ||
            row322.item.manifestcount <= 0)
        ) ? _c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.sendMANIFESTATION(row322.item)
            }
          }
        }, [_vm._v("SEND\n              MANIFESTATION")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "id": "doc",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-lock-conf",
    attrs: {
      "id": "modal-lock-conf",
      "title": "Reason for Open Locked Assignment",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remark",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.lockReason),
      callback: function($$v) {
        _vm.lockReason = $$v
      },
      expression: "lockReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeLockUnLockConfirm
    }
  }, [_vm._v(" Cancel")]), _vm._v(" "), (_vm.lockReason) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.lock_button ? true : false,
      "variant": "success"
    },
    on: {
      "click": _vm.ConfLock
    }
  }, [_vm._v("Send")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa99fbc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ffExportCon/viewFFConsoExport.vue
// module id = 2482
// module chunks = 0